import { OPERATION_COUNTRY } from './env'
import { get } from '@clara/utils'

const COUNTRIES = {
  MX: {
    // Maximum transferable amount in MXN (Mexican Pesos)
    max_transfer_amount: 999999999.99,
    max_description_length: 200,
    currency_code: 'MXN',
    currency_description: 'PESO MEXICANO',
    currency_symbol: '$',
    decimal_separator: '.',
    thousand_separator: ',',
    lang: 'es-MX',
  },
  BR: {
    // Maximum transferable amount in BRL (Brazilian Reais)
    max_transfer_amount: 999999999.99,
    max_description_length: 200,
    currency_code: 'BRL',
    currency_description: 'REAL',
    currency_symbol: 'R$',
    decimal_separator: ',',
    thousand_separator: '.',
    lang: 'pt-BR',
  },
  CO: {
    // Maximum transferable amount in COP (Colombian Pesos)
    max_transfer_amount: 999999999.99,
    max_description_length: 200,
    currency_code: 'COP',
    currency_description: 'PESO COLOMBIANO',
    currency_symbol: '$',
    decimal_separator: ',',
    thousand_separator: '.',
    lang: 'es-CO',
  },
}

type Settings = (typeof COUNTRIES)[keyof typeof COUNTRIES]

export const settings: Settings = get(COUNTRIES, OPERATION_COUNTRY, 'MX')
